<div class="mw-app-modules">
  <div class="mw-app-modules__header">
    <div class="mw-app-modules__header-title text-subtitle-2">
      {{ 'CORE.COMPONENT.APP_MODULES.title' | translate }}
    </div>
    <button mat-icon-button class="mw-icon-button-24" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="mw-app-modules__content" mwPerfectScrollBar>
    <mat-nav-list>
      <mat-list-item
        class="mw-list-item-40"
        *ngFor="let item of modules"
        (click)="onClick(item)"
        [class.mw-list-item-active]="item.title === activeModule"
      >
        <mat-icon
          class="mw-icon-20"
          [svgIcon]="item.svgIcon"
          [class.mw-icon-active]="item.title === activeModule"
        ></mat-icon>
        <div class="text-body-2">
          {{ item.title | translate }}
        </div>
      </mat-list-item>
    </mat-nav-list>
  </div>
  <div class="mw-app-modules__footer"></div>
</div>
